import { Modelo } from '@ext/index';
import * as Types from './Marca.types';
import moment ,{ Moment } from 'moment';

export class IMarca extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id : number = 0;
public Descripcion : string = '';


    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
json.descripcion = this.Descripcion;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IMarca ) {
        this.Model = Model;
    }

    public Model: IMarca;
}